export default "__VITE_PUBLIC_ASSET__802ecfd3__"